const init = () => {
    const forAll = (e, s, cb) => Array.from(e.querySelectorAll(s)).forEach(cb);
    const setActiveDay = () => {
        forAll(
            document,
            '.callback-day',
            e => {
                e.classList.toggle('is-active', e.querySelector(':checked') !== null);
                if (e.querySelector(':checked') !== null) {
                    document.getElementById('callback-submit').disabled = false;
                }
            }
        );
    };
    setActiveDay();
    forAll(document, '.callback-day input[type=radio]', e => e.addEventListener('change', setActiveDay));
    /** @type {HTMLTextAreaElement} cbMessage */
    const cbMessage = document.querySelector('form[name=callbackRequest] textarea');
    const cbMessageCountDown = document.querySelector('form[name=callbackRequest] .callback__chars-remaining');
    if (cbMessage && cbMessageCountDown) {
        const updateRemainingChars = () => cbMessageCountDown.innerText = (cbMessage.getAttribute('maxlength') * 1 - cbMessage.value.length) + '';
        updateRemainingChars();
        cbMessage.addEventListener('keyup', updateRemainingChars);
    }
};

export default {
    init,
};
